import { http } from '@pendo/http';
import { SuggestedPagesLoadEventsAggregation, AiSuggestedPagesAggregation } from '@pendo/tagging';
import { request } from '@utils/request';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

// workaround to allow aggs to run to completion for fetching page load events
// code taken from via
export async function callPageLoadEventsAgg (aggParams) {
    const spec = {
        name: 'page-load-events',
        productArea: PRODUCT_AREAS.TAGGING_AND_SETUP,
        subProductArea: SUB_PRODUCT_AREAS.SUGGESTED_PAGES,
        pipeline: SuggestedPagesLoadEventsAggregation.build(aggParams),
        responseFormat: 'default',
    };

    return request(spec);
}

export async function callAiSuggestedPagesAgg (aggParams) {
    const spec = {
        name: 'ai-suggested-pages',
        productArea: PRODUCT_AREAS.TAGGING_AND_SETUP,
        subProductArea: SUB_PRODUCT_AREAS.SUGGESTED_PAGES,
        pipeline: AiSuggestedPagesAggregation.build(aggParams),
        responseFormat: 'default',
    };

    return request(spec);
}

export async function fetchSubscriptionPageRules () {
    return http.get('/api/s/_SID_/page/uniqueRules').then((res) => res.data);
}

export function fetchSuggestedPageRulesHandledList () {
    return http.get('/api/s/_SID_/suggestedruleselection').then((res) => res.data);
}

export function updateSuggestedPageRulesHandledList ({ selections, action }) {
    const payload = {
        selections,
        type: 'page',
        action,
    };

    return http.post('/api/s/_SID_/suggestedruleselection', payload).then((res) => res.data);
}

export async function runAutoTagPagesProcess ({ selectedAppIds = [] }) {
    const payload = {
        appIds: selectedAppIds,
    };

    const response = await http.post('/api/s/_SID_/autotag/pages/', payload).then((res) => res.data);

    const { tagOk, tagTrials } = response.reduce(
        (acc, app) => {
            const tagTrialsCount = Array.isArray(app.pagesTagResults) ? app.pagesTagResults.length : 0;
            const tagOkCount = Array.isArray(app.pagesTagResults)
                ? app.pagesTagResults.filter((r) => r.pageId && r.code === 200).length
                : 0;
            acc.tagOk += tagOkCount;
            acc.tagTrials += tagTrialsCount;

            return acc;
        },
        { tagOk: 0, tagTrials: 0 },
    );

    return { tagOkTotal: tagOk, tagTrialsTotal: tagTrials };
}
